import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { CommonModule } from '@angular/common';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@mode/capra';

@Component({
  standalone: true,
  selector: 'mode-google-connection-masthead',
  imports: [CommonModule, IconComponent],
  templateUrl: './google-connection-masthead.component.html',
  styleUrls: ['./google-connection-masthead.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleConnectionMastheadComponent {
  readonly isAnalystStudio = ThoughtspotIntegrationService.currOrgIntegrated();
}
